<template>
  <div class = "text-center"> 
    <img class="circle" :src="photoUrl" v-if="photoUrl" v-bind:class="{ 'small' : small, 'medium' : medium, 'large' : large }">
    <!-- <i class="fas fa-user-circle fa-3x child3" ></i> -->

    <font-awesome-icon :icon="['fal', 'user-circle']" size="3x" v-else />
    
    </div>

</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    person: {
      required: true,
      type: Object
    },
    size: {
      required: false,
      type: String
    }
  },

  computed: {
    personName: function() {
      return this.person.firstName + ' ' + this.person.lastName;
    },
    letters: function() {
      if (this.person.firstName && this.person.lastName) {
        return (
          this.person.firstName.substring(0, 1).toUpperCase() +
          this.person.lastName.substring(0, 1).toUpperCase()
        );
      }
    },

    small() {
      return this.size == 'small';
    },
    medium() {
      return this.size == 'medium';
    },
    large() {
      return this.size == 'large';
    },
    photoUrl() {
      return this.person.photoUrl;
    },

    classes: function() {
      var colours = ['navy', 'blue', 'green', 'orange', 'pink'];
      return colours;
    },
    randomNumber: function() {
      if (this.number) {
        return Math.floor(this.number * this.classes.length);
      } else {
        return Math.floor(Math.random() * this.classes.length);
      }
    }
  },

  watch : {
    photoUrl() {
      
    }
  },

  mounted() {

  },

  components: {}
};
</script>

<style scoped>
.circle {
  width: 50px;
  height: 50px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  border-radius: 50%;
  margin: 0 auto;
  /*border: 3px solid #002c3f;*/
  /*background-image: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);*/
}

.small {
  width: 50px;
  height: 50px;
}

.medium {
  width: 80px;
  height: 80px;
}

.large {
  width: 100px;
  height: 100px;
}

.circle-letters {
  font-size: 1.4rem !important;
  text-align: center;
  /*line-height: 50px;*/
  color: #fff;
}

.navy {
  background-color: #112c40;
}
.blue {
  background-color: #84c5ed;
}
.green {
  background-color: #5fbfba;
}
.orange {
  background-color: #f18359;
}
.pink {
  background-color: #ea5187;
}
</style>
